module.exports = __webpack_public_path__ + "static/img/tap_function_airplus3_cn.087ce40.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/airplus3/tap_function_airplus3_cn.gif
// module id = 82b1
// module chunks = 1